import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  const msg =
    'Missing Supabase env. Add VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY (or VITE_SUPABASE_ANON_KEY) to .env in the project root.'
  if (import.meta.env?.DEV) {
    throw new Error(msg)
  }
  console.warn(msg)
}

// Fall back to syntactically valid placeholders when env is absent (e.g. CI
// builds without secrets, such as the Lighthouse job). createClient() throws
// on an empty URL/key, which would crash the bundle at import time and render a
// blank page (NO_FCP). With placeholders the app still paints; only live
// Supabase calls fail, which is the correct degraded behavior.
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseKey || 'placeholder-anon-key',
)
